<template>
<section>
    <section v-if="this.selectedBranch !=='' && this.$parent.branchTables.length>0">
        <div class="row">
            <div class="col-md-6 col-sm-6" style="cursor: pointer;" @click="orderTypeOpened='DineIn'">
                <div :class="(orderTypeOpened=='DineIn') ? 'order-type yellow-bg' : 'widget lazur-bg'">
                    <h3 class="text-center font-bold media-heading" >Dine In</h3>
                </div>
            </div>
            <div class="col-md-6 col-sm-6" style="cursor: pointer;" @click="orderTypeOpened='Takeaway'">
                <div :class="(orderTypeOpened=='Takeaway') ? 'order-type yellow-bg' : 'widget lazur-bg'">
                    <h3 class="text-center font-bold media-heading">Take Away</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div v-if="orderTypeOpened=='DineIn'" class="col-md-12">
                <div class="ibox-title">
                    <h3><b>Dine In Tables</b>
                      <a href="javascript:void(0)" class="float-right" @click="addNewTable"><h4><i class="fa fa-plus"></i>&nbsp;Add New Table</h4></a>
                      <a href="javascript:void(0)" class="float-right margin-2" @click="addNewWaiter" ><h4><i class="fa fa-plus"></i>&nbsp;Add New Waiter</h4></a>
                    </h3>
                </div>
                <div class="ibox-content">
                    <ul class="table-group">
                        <li class="widget style1 lazur-bg table-group-item" v-for="(table, index) in this.$parent.branchTables" :class="{'red-bg': table.status}" v-if="table.tableType===2 && !table.deleted" :key="index" @click="tableClicked($event, index, table)" :title="table.name">
                            <h2 class="media-heading" >{{ table.name.length > 15 ? table.name.slice(0, 15) : table.name }}</h2>
                        </li>
                    </ul>
                </div>

            </div>

            <div v-if="orderTypeOpened=='Takeaway'" class="col-md-12">
                <div class="ibox-title">
                    <h3><b>Take Away Slots</b>
                      <a href="javascript:void(0)" class="float-right" @click="addNewCustomerPopUp"><h4><i class="fa fa-plus"></i>&nbsp;Add New Take Away Slot</h4></a>
                    </h3>

                </div>
                <div class="ibox-content">
                    <ul class="table-group">
                        <li class="widget style1 lazur-bg table-group-item" v-for="(table, index) in this.$parent.branchTables" :class="{'red-bg': table.status}" v-if="table.tableType === 1 && !table.deleted" :key="index" @click="tableClicked($event, index, table)" :title="table.name">
                            <h2 class="media-heading">{{ table.name.length > 20 ? table.name.slice(0, 20) : table.name }}</h2>
                        </li>
                    </ul>
                </div>            

            </div>
        </div>
      <div class="modal" data-backdrop="static" data-keyboard="false" id="add_customer" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetCustomer"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title" id="assign_table_modalLabel">Add New Slot</h4>
            </div>
              <form @submit.prevent="addNewCustomer">
                <div class="modal-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label>Slot Name</label>
                        <input
                            v-model="customerName"
                            type="text"
                            class="form-control"
                            required="required"
                            placeholder="Enter Name...">
                      </div>
                      <label class="text-danger text-sm" v-if="customerExists">
                        <i>Customer Name Already Exists!</i>
                      </label>
                    </div>

                  </div>
                  <div class="row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-success pull-right">Confirm</button>
                  </div>
                </div>
                <br/>
              </div>
            </form>
          </div>
        </div>
      </div>
      <AddNewTable :selected-branch="selectedBranch" :tables="$parent.branchTables" ref="addNewTable" @updatedTableList="updatedTableList" />
      <AddNewWaiter :selected-branch="selectedBranch" :waiters="$parent.branchWaiters" :tables="$parent.branchTables" ref="addNewWaiter" @updatedWaiterList="updatedWaiterList" @updatedTableList="updatedTableList"/>
    </section>
    <!-- Waiter Modal -->
    <div class="modal" id="assign_waiter" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" v-if="this.$parent.selectedTable">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="assign_waiter_modalLabel">Assign Waiter to Table: {{this.$parent.selectedTable.name}}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="table-group">
                                <li v-for="(waiter, index) in this.$parent.branchWaiters.filter(waiter=>!waiter.deleted)" :key="index" @click="waiterClicked(waiter, index)" class="widget style1 navy-bg waiter table-group-item" :id="'waiter_' +waiter.id" style="cursor:pointer">
                                    <h2 class="media-heading">{{waiter.name}}</h2>
                                </li>
                            </ul>
                            
                        </div>       
                        <!-- </div> -->
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                                 <button class="btn btn-success pull-right" @click="initializeOrder()">Reserve Table</button>
                        </div>
                    </div>
                    <br/>
                </div>
            </div>
        </div>
    </div>
</section>
</template>


<script>
    import User from '@/services/User'
    import Multiselect from 'vue-multiselect';
    import {addTakeAwayNewTable, fetchTablesOfBranch} from "@/api/pos";
    import AddNewTable from "@/components/pos/AddNewTable.vue";
    import AddNewWaiter from "@/components/pos/AddNewWaiter.vue";
    export default {
      name: "BranchTables",
      data(){
          return {
                orderTypeOpened: "DineIn",
                restaurants: [],
                selectedRestaurant: "",
                selectedTable: "",
                customerName: "",
                branches: [],
                menu: [],
            customerExists: false,
                selectedwaiter:"",
                orderHistory: {
                        created:"",
                        statusesByStatusId:{
                            id:20,
                            name:"",
                            cssClass:""
                        }
                    },
            table: {
              "id": 0,
              "name": "",
              "tableType": 1,
            }
        }
      },
      props : ["selectedBranch", "orderTypeOpenedFromMenu"],
      watch : {
        orderTypeOpenedFromMenu: {
        handler(val) {
          this.orderTypeOpened = val
          },
          immediate: true,
          deep: true,
        }
      },
      components: {AddNewTable, Multiselect, AddNewWaiter},
        updated(){
            $('#assign_waiter').on('hidden.bs.modal', function (e) {
                $(".widget").removeClass("yellow-bg");
                this.selectedwaiter="";
             });
             $('[data-toggle="tooltip"]').tooltip();  
        },
        methods:{
          addNewTable() {
            this.$refs.addNewTable.load();
          },
          addNewWaiter() {
            this.$refs.addNewWaiter.load();
          },
          updatedTableList(tables) {
            this.$parent.branchTables = tables
          },
          updatedWaiterList(waiters) {
            this.$parent.branchWaiters = waiters
          },
          addNewCustomerPopUp() {
            $("#add_customer").modal("show");
          },
          async addNewCustomer() {
            try {
              if (this.$parent.branchTables.find(e=>e.name.toLowerCase() === this.customerName.toLowerCase() && e.tableType === 1 )) {
                this.customerExists = true
                return
              }
              this.customerExists = false
              this.table.name = this.customerName
              this.table.status = 0
              this.table.branch = this.selectedBranch
              await addTakeAwayNewTable(this.table)
              let param= new URLSearchParams();
              param.append("branch_id", this.selectedBranch.id);
              const {data} =  await fetchTablesOfBranch(param)
              this.$parent.branchTables = data
            } catch (e) {
              this.showErrorMessage(e)
            }
            this.resetCustomer()
            $("#add_customer").modal("hide");
          },
          resetCustomer() {
            this.customerName = ''
            this.customerExists = false
          },
          tableClicked: async function(event, index, table) {
              this.selectedwaiter="";
              this.$parent.selectedTableIndex= index;
              this.$parent.selectedTable= Object.assign({}, table);
              if(table.tableType===2){
                  if(!this.$parent.selectedTable.status){
                      this.$parent.orderObject.orderTypesByOrderTypeId.id= "2";
                      this.$parent.orderObject.orderTypesByOrderTypeId.type="Dine In";
                      $("#assign_waiter").modal("show");
                      $(".widget").removeClass("yellow-bg");
                      $('#'+table.id).addClass("yellow-bg");
                  }
                  else{
                      this.$parent.selectedTableOrder= await this.$parent.getOrderObject(table.id)
                  }
              }else if(table.tableType===1){
                  if(!this.$parent.selectedTable.status){
                      this.$parent.orderObject.orderTypesByOrderTypeId.id= "1";
                      this.$parent.orderObject.orderTypesByOrderTypeId.type="Take Away";
                      this.selectedwaiter="";
                      this.initializeOrder();
                  }else{
                      this.$parent.selectedTableOrder= await this.$parent.getOrderObject(table.id)
                  }
              }

          },
          waiterClicked: function(waiter, waiterIndex){ //selected waiter
              this.selectedwaiter= waiter;
              $(".waiter").removeClass('yellow-bg')
              $('#waiter_'+ waiter.id).addClass('yellow-bg');
          },
          initializeOrder: async function(){ //initialilze order--save this in local storage
                this.$parent.selectedTable.status= 1;

                let param= new URLSearchParams();
                param.append("table_id", this.$parent.selectedTable.id);
                param.append("table_status", this.$parent.selectedTable.status);
                this.$http.post(this.$store.state.mainAppURL + "pos/update_table_status", param) //update status to reserved in db
                .then(async resp=>{
                    console.log("Table Updated in database");

                if (this.selectedwaiter!=="") {
                    this.$parent.orderObject.waiter= this.selectedwaiter;
                }else{
                    this.$parent.orderObject.waiter=null;
                }
                this.$parent.orderObject.table= this.$parent.selectedTable;

                    // creating order initilize history
                    let date= new Date();
                    this.$parent.status.id=20;
                    this.$parent.orderHistory.created= date.getTime();
                    this.$parent.orderHistory.statusesByStatusId.id=20;
                    this.$parent.orderHistory.statusesByStatusId.name= "CREATED";
                    this.$parent.orderObject.orderHistoriesById.push(this.$parent.orderHistory);

                    let user= JSON.parse(localStorage.getItem("user"));
                    this.$parent.orderObject.usersByUserId.id= user.id;
                    this.$parent.orderObject.usersByUserId.fullName= user.fullName;
                    this.$parent.orderObject.branchesByBranchId= this.selectedBranch;
                    this.$parent.orderObject.paymentMethod.id=0;

                    await this.$parent.updateOrderObject(this.$parent.orderObject, this.$parent.selectedTable.id);
                    this.$parent.selectedTableOrder= await this.$parent.getOrderObject(this.$parent.selectedTable.id)
                    this.$parent.orderObject.orderHistoriesById=[];

                    this.selectedwaiter="";

                })
              $('#assign_waiter').modal("hide");
              const selectedTableId = this.$parent.selectedTable.id;
              const tableIndex = this.$parent.branchTables.findIndex(table => table.id === selectedTableId);

              if (tableIndex !== -1) {
                this.$parent.branchTables[tableIndex].status = 1;
              }
            }
        }
    }
</script>
<style>
.table-group{
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    justify-content: flex-start;
}

.table-group-item{
    margin: 10px;
    list-style: none;
    width: 200px;
    max-width: 200px;
    max-height: 120px;
    height: 120px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
    -webkit-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
    -moz-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
}
.c2d_cont_1{
    /* height: 220px !important; */
    overflow: auto;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9{
    /* padding-right: 4px !important;
    padding-left: 4px !important; */
}

.wrap-overflow{
  white-space: nowrap; 
  width: 70%; 
  overflow: hidden;
  margin-left: 2px;
}
.waiter-group{
    display: flex;
	justify-content: center;
	flex-wrap: wrap;
}
.waiter-group-item{
    flex-basis: 30%;
    margin-right: 2%;
}
.table-box{
    width: 100px;
    height: 100px;
}
.order-type {
  border-radius: 5px;
  padding: 15px 20px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.float-right {
  float: right;
}
.margin-2 {
  margin-right: 2rem;
}
</style>